import { withIcon } from './withIcon';

const BagSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1293 7.27711C16.391 6.55445 15.4106 6.13258 14.3793 6.09742V5.41383C14.3793 4.17945 13.8598 3.00758 12.9457 2.17555C12.0317 1.33961 10.809 0.93336 9.57464 1.05836C7.32464 1.38648 5.64886 3.30445 5.62542 5.57789V6.09742C4.59417 6.13258 3.6137 6.55445 2.87542 7.27711C2.18792 8.17555 1.91448 9.32399 2.12933 10.4334L2.75042 15.4216C2.93792 17.1677 3.64886 18.9568 7.50042 18.9568H12.5004C16.352 18.9568 17.0629 17.1677 17.2504 15.4334L17.8754 10.4216C18.0864 9.31617 17.8168 8.17164 17.1293 7.27711ZM6.87542 5.57789C6.89886 3.94898 8.08636 2.57008 9.69183 2.30836C11.4106 2.13648 12.9418 3.3943 13.1098 5.10914C13.1215 5.2107 13.1254 5.31227 13.1254 5.41773V6.04273H6.87542V5.57789ZM14.2739 15.1365C14.5082 15.3709 14.5082 15.7537 14.2739 15.992L13.4184 16.8474C13.184 17.0818 12.8012 17.0818 12.5629 16.8474L10.0004 14.2849L7.43792 16.8474C7.20354 17.0818 6.82073 17.0818 6.58245 16.8474L5.72698 15.992C5.49261 15.7576 5.49261 15.3748 5.72698 15.1365L8.28948 12.574L5.72698 10.0115C5.49261 9.77711 5.49261 9.3943 5.72698 9.15602L6.58245 8.30055C6.81683 8.06617 7.19964 8.06617 7.43792 8.30055L10.0004 10.863L12.5629 8.30055C12.7973 8.06617 13.1801 8.06617 13.4184 8.30055L14.2739 9.15602C14.5082 9.39039 14.5082 9.7732 14.2739 10.0115L11.7114 12.574L14.2739 15.1365Z"
      fill="currentColor"
    />
  </svg>
);

export const BagWithCross = withIcon(BagSvg);
